if (!customElements.get('product-per-insert')) {
  customElements.define(
    'product-per-insert',
    class productPerInsert extends HTMLElement {
      constructor() {
        super();

        this.addToCartBtn = document.querySelector('.button.add-to-cart');
        if (this.addToCartBtn) {
          this.addToCartBtn.disabled = true;
          this.addToCartBtn.setAttribute('aria-disabled', true);
        }

        this.productSubtotals = document.querySelectorAll('.product-subtotal-component');

        if (this.productSubtotals && this.productSubtotals.length > 0) {
          this.productSubtotals.forEach((element) => {
            element.style.display = 'none';
          });
        }

        this.errorMessage = document.querySelector('.message-error');
        this.errorMessageText = this.errorMessage.querySelector('.message');

        this.numberMax = {length: 24, width: 24, depth: 8};
        let that = this;
        document.addEventListener('input', function (e) {
          for (let target = e.target; target && target != this; target = target.parentNode) {
            if (target.matches('.input-size')) {
              that.setInputs();
              break;
            }
          }
        });

        document.addEventListener(
          'click',
          function (e) {
            for (let target = e.target; target && target != this; target = target.parentNode) {
              let countProduct = that.querySelectorAll('.size-item-wrapper').length;
              if (target.matches('.size-item-remove')) {
                if (countProduct > 1) {
                  target.closest('.size-item-wrapper').remove();
                  that.resetName();
                  that.setInputs();
                }
                break;
              }
              if (target.matches('.add-new')) {
                if (countProduct < 5) {
                  let productNew = `
                  <div class="size-item-wrapper">
                    <div class="size-item border-top-radius">
                      <div class="add-new">
                        <div class="h-line"></div>
                        <div class="v-line"></div>
                      </div>
                      <span class="size-item-name">Product ${countProduct + 1}</span>
                      <div class="size-item-sizes">

                        <div class="size-input">
                          <div class="input-component size-small" data-type="length">
                            <input class="input-length input-size" min="1" step="0.01" type="number" placeholder=" " autofocus="false" required="required" autocomplete="false" id="size-input-length-${
                              countProduct + 1
                            }" />
                            <label for="size-input-length-${countProduct + 1}">Length</label>
                          </div>
                        </div>

                        <div class="size-input">
                          <div class="input-component size-small" data-type="width">
                            <input class="input-width input-size" min="1" step="0.01" type="number" placeholder=" " autofocus="false" required="required" autocomplete="false" id="size-input-width-${
                              countProduct + 1
                            }" />
                            <label for="size-input-width-${countProduct + 1}">Width</label>
                          </div>
                        </div>

                        <div class="size-input">
                          <div class="input-component size-small" data-type="depth">
                            <input class="input-depth input-size" min="1" step="0.01" type="number" placeholder=" " autofocus="false" required="required" autocomplete="false" id="size-input-depth-${
                              countProduct + 1
                            }"/>
                            <label for="size-input-depth-${countProduct + 1}">Depth</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="size-item-remove">
                      <div class="h-line"></div>
                      <div class="v-line"></div>
                    </div>
                  </div>`;
                  let insert = new DOMParser().parseFromString(productNew, 'text/html');
                  let containerProductsPerInsert = document.querySelector('.content-products-per-insert');

                  containerProductsPerInsert.appendChild(insert.querySelector('.size-item-wrapper'));
                }
                that.resetName();
                break;
              }
            }
          },
          false,
        );
      }

      get reformat() {
        return {
          width: 'width',
          length: 'length',
          height: 'depth',
        };
      }

      get dimensions() {
        return ['height', 'length', 'width'];
      }

      set customSize(object) {
        /*FOR 1X
        L = (L Value of Object 1) + 1.5
        W = (W Value of Object 1) + 1.5
        H = (H Value of Object 1) + 0.5 */
        let sumL = 1.5,
          sumW = 1.5,
          sumD = 0.5,
          generateCustomSize = document.querySelectorAll('.generate-custom-size'),
          temL,
          temW,
          temD;

        temL = parseFloat(Math.max(...object['length'])) + sumL;
        temW = parseFloat(Math.max(...object['width'])) + sumW;
        temD = parseFloat(Math.max(...object['depth'])) + sumD;

        if (object['length'].length === 2) {
          /*FOR 2X
          L = (W Value of Object 1) + (W Value of Object 2) + 2.25
          W = (Largest L Value recorded from the two objects) + 1.5
          H = (Largest H Value recorded from the two objects) + 0.5 */
          sumL = 2.25;
          sumW = 1.5;
          sumD = 0.5;
          temL = parseFloat(object['width'].reduce((a, b) => parseFloat(a) + parseFloat(b), 0)) + sumL;
          temW = parseFloat(Math.max(...object['length'])) + sumW;
          temD = parseFloat(Math.max(...object['depth'])) + sumD;
        }

        if (object['length'].length === 3) {
          /*FOR 3X
          L = (W Value of Object 1) + (W Value of Object 2) + (W Value of Object 3) + 3
          W = (Largest L Value recorded from the three objects) + 1.5
          H = (Largest H Value recorded from the three objects) + 0.5 */
          sumL = 3;
          sumW = 1.5;
          sumD = 0.5;
          temL = parseFloat(object['width'].reduce((a, b) => parseFloat(a) + parseFloat(b), 0)) + sumL;
          temW = parseFloat(Math.max(...object['length'])) + sumW;
          temD = parseFloat(Math.max(...object['depth'])) + sumD;
        }

        if (object['length'].length === 4) {
          /*FOR 4X
          L = (W Value of Object 1) + (W Value of Object 2) + (W Value of Object 3) + (W Value of Object 4) + 3.75
          W = (Largest L Value recorded from the three objects) + 1.5
          H = (Largest H Value recorded from the three objects) + 0.5 */
          sumL = 3.75;
          sumW = 1.5;
          sumD = 0.5;
          temL = parseFloat(object['width'].reduce((a, b) => parseFloat(a) + parseFloat(b), 0)) + sumL;
          temW = parseFloat(Math.max(...object['length'])) + sumW;
          temD = parseFloat(Math.max(...object['depth'])) + sumD;
        }

        if (object['length'].length === 5) {
          /*FOR 5X
          L = (W Value of Object 1) + (W Value of Object 2) + (W Value of Object 3) + (W Value of Object 4) + (W Value of Object 5) 4.5
          W = (Largest L Value recorded from the three objects) + 1.5
          H = (Largest H Value recorded from the three objects) + 0.5 */
          sumL = 4.5;
          sumW = 1.5;
          sumD = 0.5;
          temL = parseFloat(object['width'].reduce((a, b) => parseFloat(a) + parseFloat(b), 0)) + sumL;
          temW = parseFloat(Math.max(...object['length'])) + sumW;
          temD = parseFloat(Math.max(...object['depth'])) + sumD;
        }

        const dimensions = {
          width: temL,
          length: temW,
          height: temD,
        };

        if (this.checkMaxValues(dimensions) || this.validValues(dimensions)) {
          let message = '';
          if (this.validValues(dimensions)) message = 'Length or Width > Depth';
          if (this.checkMaxValues(dimensions)) message = 'max size of W=24 L=24 D=8';

          this.errorMessageText.innerHTML = message;
          this.errorMessage.classList.remove('hidden');

          if (this.addToCartBtn) {
            this.addToCartBtn.disabled = true;
            this.addToCartBtn.setAttribute('aria-disabled', true);
          }
        } else if (generateCustomSize.length > 0) {
          this.errorMessage.classList.add('hidden');

          if (this.addToCartBtn) {
            this.addToCartBtn.disabled = false;
            this.addToCartBtn.setAttribute('aria-disabled', false);
          }

          if (this.productSubtotals && this.productSubtotals.length > 0) {
            this.productSubtotals.forEach((element) => {
              element.style.display = 'flex';
            });
          }
        }

        if(this.checkInputs()) {
          generateCustomSize.forEach((element) => {
            element.dataset.value = `${temL}x${temW}x${temD}`;
            element.innerHTML = `${temL}x${temW}x${temD}`;

            element.dispatchEvent(new Event('change'));
          });
        }else {
          this.clearCustomSize();
          this.disabledButton();
        }
      }

      clearCustomSize() {
        let generateCustomSize = document.querySelectorAll('.generate-custom-size');
        generateCustomSize.forEach((element) => {
          element.dataset.value = '';
          element.innerHTML = '';
        });
      }

      checkInputs() {
        let validation = true;
        let containerProductsInsert = this.querySelectorAll('.size-item-wrapper');
        containerProductsInsert.forEach((product) => {
          product.querySelectorAll('.input-component').forEach((inputComponent) => {
            let input = inputComponent.querySelector('input');
            input.required = true;
            if (!input.checkValidity() || input.value == '') {
              validation = false;
            }
          });
        });
        return validation;
      }

      validValues(currentDimensions) {
        let validation = false;
        this.dimensions.forEach((dimension) => {
          if (dimension != 'height' && currentDimensions['height'] > currentDimensions[dimension]) {
            validation = true;
          }
        });
        if (validation) this.InvalidInput('height');

        return validation;
      }

      checkMaxValues(currentDimensions) {
        let validation = false;

        this.dimensions.forEach((dimension) => {
          if (currentDimensions[dimension] > this.numberMax[dimension]) {
            this.InvalidInput(dimension);
            validation = true;
          }
        });

        return validation;
      }

      InvalidInput(dimension) {
        const reformat = this.reformat[dimension];
        let containerProductsInsert = this.querySelectorAll('.size-item-wrapper');
        containerProductsInsert.forEach((product) => {
          product.querySelectorAll('.input-component').forEach((inputComponent) => {
            let type = String(inputComponent.dataset.type);
            let input = inputComponent.querySelector('input');

            if (input.value != '' || input.checkValidity()) {
              if (type == reformat) {
                input.classList.add('ng-invalid');
              } else {
                input.classList.remove('ng-invalid');
              }
            }else {
              input.classList.remove('ng-invalid');
            }
          });
        });
      }

      setInputs() {
        let size = {
          length: [],
          width: [],
          depth: [],
        };
        let containerProductsInsert = this.querySelectorAll('.size-item-wrapper');
        containerProductsInsert.forEach((product) => {
          let tempSize = {
            length: null,
            width: null,
            depth: null,
          };

          product.querySelectorAll('.input-component').forEach((inputComponent) => {
            let type = String(inputComponent.dataset.type);
            let input = inputComponent.querySelector('input');

            if (input.value != '') {
              if (parseFloat(this.numberMax[type]) <= parseFloat(input.value)) {
                input.classList.add('ng-invalid');
              } else {
                input.classList.remove('ng-invalid');
              }
              tempSize[type] = input.value;
            }else if(!input.checkValidity()) {
              input.classList.add('ng-invalid');
            }
          });

          let {length, width, depth} = tempSize;
          if (length && width && depth) {
            for (let key in tempSize) {
              if (tempSize.hasOwnProperty(key)) {
                size[key].push(tempSize[key]);
              }
            }
          }
        });

        if (size['length'].length > 0) {
          this.customSize = size;
        }

        if (this.querySelectorAll('input.input-size.ng-invalid').length > 0) {
          if (this.productSubtotals && this.productSubtotals.length > 0) {
            this.productSubtotals.forEach((element) => {
              element.style.display = 'none';
            });
          }

          if (this.addToCartBtn) {
            this.addToCartBtn.disabled = true;
            this.addToCartBtn.setAttribute('aria-disabled', true);
          }
        }
      }

      resetName() {
        let containerProductsInsert = this.querySelectorAll('.size-item-wrapper');
        let hideNewInsert = containerProductsInsert.length == 5 ? true : false;
        containerProductsInsert.forEach((product, index) => {
          product.querySelectorAll('.input-component').forEach((inputComponent) => {
            let type = String(inputComponent.dataset.type);
            let input = inputComponent.querySelector('input');
            let label = inputComponent.querySelector('label');
            let tempID = `size-input-${type}-${index + 1}`;
            label.htmlFor = tempID;
            input.id = tempID;
          });

          if (hideNewInsert && index == 0) {
            product.querySelector('.add-new').style.display = 'none';
          } else if (!hideNewInsert && index == 0) {
            product.querySelector('.add-new').style.display = 'block';
          }
          product.querySelector('.size-item-name').innerHTML = `Product ${index + 1}`;
        });
      }

      disabledButton() {
        if (this.addToCartBtn) {
          this.addToCartBtn.disabled = true;
          this.addToCartBtn.setAttribute('aria-disabled', true);
        }
      }
    },
  );
}
